
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/confirm-identity",
      function () {
        return require("private-next-pages/confirm-identity.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/confirm-identity"])
      });
    }
  